var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/modules/$.has.js
// module id = ./node_modules/vue2-google-maps/node_modules/core-js/library/modules/$.has.js
// module chunks = 0